import { createSlice } from '@reduxjs/toolkit';

const modalSlice = createSlice({
  name: 'myFeature',
  initialState: {
    showEnquireModal: false,
    enquiryProduct: null,
  },
  reducers: {
    setShowEnquireModal: (state, action) => {
      state.showEnquireModal = action.payload;
    },
    setEnquiryProduct: (state, action) => {
      state.enquiryProduct = action.payload;
    },
  },
});

export const {
  setShowEnquireModal,
  setEnquiryProduct
} = modalSlice.actions;

export default modalSlice.reducer;
